
export function isEven(number: number): boolean {
  return number % 2 === 0;
}

export function isOdd(number: number): boolean {
  return number % 2 !== 0;
}
